import {useTranslation} from "react-i18next";
import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import {
    BackIcon,
} from "../../../../../asset";
import {Skeleton, Tabs} from "antd";
import style from "../add/AddTripPlanning.module.css";
import PrimaryButton from "../../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../../component/button/SecondaryButton";
import ModalTrip from "../../../../../component/modal/ModalTrip";
import ModalSuccessAdd from "../../../../../component/modal/ModalSuccessAdd";
import useDetailTripPlan from "./detail-trip-plan.hooks";
import TabTrip from "./tab-trip/tab-trip";
import TabOrderNotAssign from "./tab-order-not-assign/tab-order-not-assign";
import TabReview from "./tab-review/tab-review";
import NotifFailedSaved from "../../../../../component/modal/NotifFailedSaved";

const DetailTripPlanning = () => {
    const {t} = useTranslation();

    const {
        data,
        skeleton,
        startOpen,
        endOpen,
        successModalOpen,
        messages,
        location,
        failedModalOpen,
        backToList,
        _btnApproved,
        _btnReject,
        setEndOpen,
        actModal,
        setStartOpen,
        setFailedModalOpen,
    } = useDetailTripPlan();

    const items = [
        {
            key: 1,
            label: t("Trip"),
            children: <TabTrip/>,
        },
        {
            key: 2,
            label: t("Order Not Assign"),
            children: <TabOrderNotAssign/>,
        },
        {
            key: 3,
            label: t("Review"),
            children: <TabReview/>,
        },
    ];

    return (
        <>
            <div className="p-[24px] flex flex-col gap-[24px]">
                <div className="flex flex-row gap-5">
                    <Breadcumbs
                        jmlLevel={4}
                        menuLevel1={`Order`}
                        menuLevel2={`Routes`}
                        menuLevel3={`Trip Planning`}
                        menuLevel4={`Detail ${location?.state?.data?.trip_plan_name} - ${location?.state?.data?.order}`}
                    />
                    <div
                        className={`${
                            data?.status === "Waiting Approval"
                                ? "bg-[#F8AC301A]"
                                : data?.status === "Reject"
                                    ? "bg-[#FF00001A]"
                                    : data?.status === "Approved"
                                        ? "bg-[#57C22D1A]"
                                        : ""
                        } flex justify-center items-center px-2 h-[23px] rounded-[9px]`}
                    >
                        {" "}
                        <p
                            className={`font-roboto font-medium text-base 
              ${
                                data?.status === "Waiting Approval"
                                    ? "text-[#F8AC30]"
                                    : data?.status === "Reject"
                                        ? "text-[#FF0000]"
                                        : data?.status === "Approved"
                                            ? "text-[#57C22D]"
                                            : ""
                            }`}
                        >
                            {data?.status}
                        </p>{" "}
                    </div>
                </div>

                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-[22px]">
                        <img
                            src={BackIcon}
                            alt=""
                            onClick={() => backToList()}
                            className="cursor-pointer"
                        />
                        <h1 className="font-sans-bold text-2xl" id="title">
                            {`Detail ${location?.state?.data?.trip_plan_name} - ${location?.state?.data?.order}`}
                        </h1>
                    </div>
                </div>

                <div
                    style={{
                        marginTop: 24,
                        padding: 30,
                        minHeight: 512,
                        borderRadius: "6px",
                        backgroundColor: "white",
                        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                    }}
                >
                    {skeleton ? (
                        <Skeleton active/>
                    ) : (
                        <div className={style.tabsContainer + ""}>
                            <Tabs
                                defaultActiveKey="1"
                                items={items}
                                className="border-b border-[#ffffff]"
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-row-reverse gap-[16px] m-5">
                <PrimaryButton
                    action={() => setStartOpen(true)}
                    text={t("Approve")}
                    disabled={data?.status !== "Waiting Approval" ? true : false}
                />
                <SecondaryButton
                    action={() => setEndOpen(true)}
                    text={t("Reject")}
                    disabled={data?.status !== "Waiting Approval" ? true : false}
                />
            </div>
            <ModalSuccessAdd
                show={successModalOpen}
                action={() => actModal()}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description={messages}
            />
            <NotifFailedSaved
                visible={failedModalOpen}
                message={messages}
                action={() => {
                    setFailedModalOpen(false);
                }}
            />

            <ModalTrip
                visible={startOpen}
                message={`The trip status will appear on "All Trip Menu"`}
                title="Approve Trip?"
                type="Approve"
                onClick={() => setStartOpen(false)}
                action={() => _btnApproved()}
            />
            <ModalTrip
                visible={endOpen}
                message={`The trip status will change to "Rejected"`}
                title="Reject Trip"
                type="Reject"
                onClick={() => setEndOpen(false)}
                action={() => _btnReject()}
            />
        </>
    );
};
export default DetailTripPlanning;
